import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import {errorMessage$, successMessage$} from '../../../utils/subjects';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function DialogDateOutTypeDelete({handleClose, handleOpen, open, id, callback}) {
  const classes = useStyles();
  const [description, setDescription] = useState('');
  const [dateOutTypeId] = useState(id);

  useEffect(() => {
    const loadDateOutType = async () => {
      try {
        const dateOutType = await api.get(`scheduling/date-out-types/${dateOutTypeId}`);
        setDescription(dateOutType.data.Description);
  
      } catch (err) {
        errorMessage$.next({open: true, message: 'Error to get date out type information'});
      }
    }

    loadDateOutType();
  }, [dateOutTypeId])


  async function handleSubmit(e) {
    e.preventDefault();

    try {
      handleClose();
      await api.delete(`scheduling/date-out-types/${dateOutTypeId}`);
      
      successMessage$.next({open: true, message: 'Date out type deleted successfully'});
      if (callback) callback();

    } catch (err) {
      errorMessage$.next({open: true, message: 'Error on delete date out type'});
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Do you confirm?</DialogTitle>
      <form className={classes.root} onSubmit={handleSubmit}>
        <DialogContent>
          <p>Do you would to like to delete <strong style={{ fontWeight: 500 }}>"{description}"</strong>?</p>
          <p>If this type already in use on any allocation, you should not able to delete it.</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Delete
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}